import { Box } from '@material-ui/core'

import React, { FC } from 'react'

const InLineBox: FC<any> = ({
  items,
  padding = 2,
  margin = 1,
  fontSize = 16
}: {
  items: { [key: string]: any }
  padding?: number
  margin?: number
  fontSize?: number
  [key: string]: any
}) => (
  <>
    {Object.keys(items).map((key) => (
      <Box
        component="span"
        display="line"
        p={padding}
        m={margin}
        bgcolor="background.paper"
        key={key}
        fontSize={fontSize}
      >{`${key}: ${items[key]}`}</Box>
    ))}
  </>
)

export default InLineBox
